import PressReleaseLayout from "./PressReleaseLayout.tsx";
import {useParams} from "react-router-dom";
import {useMemo} from "react";
import {pressReleases} from "../releases.ts";
import NotFoundPage from "../../NotFoundPage.tsx";
import useRouteDatalayer from "../../../components/useRouteDatalayer.tsx";

export default function PressReleasePage() {
    useRouteDatalayer("presse")
    const {release_query} = useParams()

    const release = useMemo(() => {
        if (!((release_query as string) in pressReleases)) {
            return false
        }

        return pressReleases[release_query as string]
    }, [release_query])

    if (release === false) {
        return <NotFoundPage link_back={"/presse"} link_title={"Gå tilbage til presse."}/>
    }

    return (
        <PressReleaseLayout release={release}/>
    )
}
